import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL ,
    withCredentials: true,
});

//console.log('API Base URL:', process.env.REACT_APP_SERVER_URL); // Debug to confirm it's defined
export default api;
